
import { Component } from "nuxt-property-decorator"
import Footer from "~/mixins/footer"

@Component
export default class TheFooterComponent extends Footer {
  // TODO Tracking should be added to click on PhoneNumber
}
